<template>
  <div class="page-bottom">
    <div :class="['pagination-promo', bundle]">
      <div class="prev" @click="prev()">
        <img src="/modules/custom/vue_apps/assets/source/static/images/prev.svg">
      </div>
      <div class="next" @click="next()">
        <img src="/modules/custom/vue_apps/assets/source/static/images/next.svg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'bundle'
  ],

  methods: {
    prev () {
      this.$emit('prev')
    },

    next () {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss">
.pagination-promo {
  display: flex;
  .prev, .next {
    padding: 10px;
    cursor: pointer;
    background: rgba(45, 156, 219, 0.1);
    transition: background .3s ease;
    &:hover {
      background: rgba(45, 156, 219, 0.4);
    }
  }

  &.component_icon_section {
    float: right;
  }
}
</style>